import React, { useEffect, useRef } from "react";
import styled from 'styled-components';
import { Modal } from 'bootstrap/dist/js/bootstrap';

const ModalStyled = styled.div`
	background: rgba(0, 0, 0, 0.4);
	position: fixed;
	inset: 0;
	z-index: 1050;
	display: flex !important;
	align-items: center;
	justify-content: center;

	.modal-title {
		text-transform: uppercase;
		color: var(--bs-gray-700);
		font-size: 15px;
		padding-left: 0px;
		padding-right: 40px;
	}

	.modal-header, .modal-footer {
		border: none;
	}
`;

export default React.memo(function ConfirmModal(props) {
	const modalRef = useRef(null);

	const closeCallback = props.closeCallback;
	const confirmCallback = props.confirmCallback;

	useEffect(() => {
		const modal = new Modal(modalRef.current, { backdrop: false });

		const hiddenEvent = () => {
			modal._element.removeEventListener('hidden.bs.modal', hiddenEvent);
			modal.dispose();
			closeCallback();

			document.body.style.overflow = 'auto';
			document.body.style.paddingRight = '0';
		};

		modal._element.addEventListener('hidden.bs.modal', hiddenEvent);
		modal.show();
	}, [closeCallback]);

	const handleConfirm = () => {
		const modal = Modal.getInstance(modalRef.current);
		modal.hide();
		confirmCallback();
	};

	return (
		<ModalStyled className="modal" tabIndex="-1" ref={modalRef}>
			<div className="modal-dialog modal-sm">
				<div className="modal-content">
					<div className="modal-header px-4 pt-4">
						<h5 className="modal-title">{props.title ?? 'Confirmar'}</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body px-4 text-center">
						<p className="mb-0">{props.message ?? '¿Estás seguro?'}</p>
					</div>
					<div className="modal-footer gap-2 px-4 pb-4 justify-content-center">
						<button type="button" className="btn btn-sm btn-plenoil btn-plenoil-outline-blue mb-2" style={{ width: 'max-content' }} data-bs-dismiss="modal">No</button>
						<button type="button" className="btn btn-sm btn-plenoil btn-plenoil-orange mb-2" style={{ width: 'max-content' }} onClick={handleConfirm}>Sí</button>
					</div>
				</div>
			</div>
		</ModalStyled>
	);
}, () => true);
